import { staticText } from 'utils/staticText';

// todo cms-1622 remove unused keys
export const ApplyStaticText = staticText({
  applyNow: {
    _: 'Apply Now',
    'zh-hk': '立即申請',
  },
  applyingForCard: {
    _: 'You are applying for :productName',
    'zh-hk': '你正在申請 :productName',
  },
  applyModalErrorTitle: {
    _: 'Something went wrong',
    'zh-hk': '發生錯誤',
  },
  applyModalErrorSubtitle: {
    _: 'We could not load this product. Please try again.',
    'zh-hk': '無法載入此產品，請再試一次。',
  },
  applyModalTryAgain: {
    _: 'Try again',
    'zh-hk': '再試一次',
  },
  applyForCardOnly: {
    _: 'No thanks, just apply for card',
    'zh-hk': '不用了，只申請此產品',
  },
  applyWithBundle: {
    _: 'Apply with :bundleName',
    'zh-hk': '以 :bundleName 申請',
  },
  campaignFallbackRewardDescription: {
    _: 'Description (top up if have)',
  },
  bundleDisclaimer: {
    _: 'Note: Choosing a bundle replaces your standalone reward with the bundle reward. You get the bundle reward instead, not both.',
    'zh-hk':
      '注意：一旦選擇升級獎賞，將會取代你原本的單獨獎賞；你只會獲得升級獎賞，不會兩者兼得。',
  },
  bundleHeroDescription: {
    _: 'Bundle more products with your :productName to unlock up to :rewardValue in rewards — pick an option below.',
    'zh-hk':
      '將更多產品與你的 :productName 一併申請，即可解鎖高達 :rewardValue 的獎賞，請於下方選擇。',
  },
  bundleHeroDescriptionNoValue: {
    _: 'Bundle more products with your :productName to unlock a bigger reward — pick an option below.',
    'zh-hk':
      '想要更多獎賞？將更多產品與 :productName 一併申請，即可解鎖更豐厚的獎賞，請於下方選擇。',
  },
  bundleHeroTitle: {
    _: 'Want a bigger reward?',
    'zh-hk': '想獎賞更上一層？',
  },
  copied: {
    _: 'Copied',
    'zh-hk': '已複製',
  },
  copyPromoCode: {
    _: 'Copy promo code',
    'zh-hk': '複製指定邀請碼',
  },
  emailAddressLabel: {
    _: 'Email address',
    'zh-hk': 'Email',
  },
  emailInvalid: {
    _: 'Please enter a valid email address.',
    'zh-hk': '請輸入有效的電子郵件地址。',
  },
  emailPlaceholder: {
    _: 'yourname@gmail.com',
  },
  emailRequired: {
    _: 'Please enter your email address.',
    'zh-hk': '請輸入您的電子郵件地址。',
  },
  flashDeal: {
    _: 'Flash Deal! Limited time offer',
  },
  footerCopyright: {
    _: '© 2021 - ${currentYear} SingSaver Pte. Ltd. All rights reserved.',
    'en-hk':
      '© 2013 - ${currentYear} MoneyHero Global Limited (registered in Hong Kong under company number 1864714) (“MHGL”). All rights reserved.',
    'zh-hk':
      '© 2013 - ${currentYear} MoneyHero Global Limited（於香港註冊，公司編號為 1864714）(“MHGL”)。版權所有。',
  },
  footerLinksSeparator: {
    _: '|',
  },
  identitySwitchFailed: {
    _: 'Something went wrong. Please try again.',
    zh: '出現問題，請再試一次。',
  },
  marketingConsentAriaLabel: {
    _: 'Marketing consent',
    'zh-hk': '營銷資料同意',
  },
  noSelectedExclusiveOffer: {
    _: 'Selected :brand Exclusive Offer',
    'zh-hk': '已選獨家獎賞',
  },
  privacyPolicy: {
    _: 'Privacy Policy',
    'zh-hk': '隱私政策',
  },
  promoCode: {
    _: 'Promo Code:',
    'zh-hk': '指定邀請碼：',
  },
  promoCodeLabel: {
    _: 'Promo Code',
    zh: '指定優惠碼',
  },
  // SingSaver only (CMS-1959), so no ZH-HK copy.
  promoCodeTooltip: {
    _: 'Copy this promo code and paste it when you submit your application to qualify for your sign-up reward.',
  },
  selectBundleAbove: {
    _: 'Select a bundle above',
    'zh-hk': '選擇升級獎賞',
  },
  selectedPromoCode: {
    _: 'Promo code copied',
    'zh-hk': '已複製指定邀請碼',
  },
  sessionEnded: {
    _: 'Your session ended. Please enter your email.',
    zh: '登入時效已過，請輸入電郵地址。',
  },
  seeFullDetails: {
    _: 'See Full Details',
    'zh-hk': '查看完整詳情',
    'zh-tw': '查看完整資訊',
  },
  seeMore: {
    _: 'see more',
    'zh-hk': '查看更多',
  },
  seeLess: {
    _: 'see less',
    'zh-hk': '收起',
  },
  step1Label: {
    _: 'Enter Email',
    'zh-hk': '輸入 Email',
  },
  step1Title: {
    _: 'STEP 1',
  },
  step2Label: {
    _: 'Apply for Card',
    'zh-hk': '申請產品',
  },
  // Where the form also serves loans (CMS-1959), the step names no vertical.
  step2LabelProduct: {
    _: 'Apply for Product',
  },
  step2Title: {
    _: 'STEP 2',
  },
  step3Label: {
    _: 'Redeem Reward',
    'zh-hk': '兌換獎賞',
  },
  step3Title: {
    _: 'STEP 3',
  },
  termsAndConditions: {
    _: 'Terms & Conditions',
    'zh-hk': '條款及細則',
  },
  upgradeTo: {
    _: 'Upgrade To',
    'zh-hk': '升級獎賞',
  },
  useDifferentEmail: {
    _: 'Not you? Use a different email',
    zh: '不是你？使用其他電郵地址',
  },
  yourCurrent: {
    _: 'Your Current',
    'zh-hk': '目前獎賞',
  },
});
